var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgItem = function SvgItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 54,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M25.893 8.56 24.602 0H5.65C2.797 0 .53 2.325.53 5.178v35.836a5.096 5.096 0 0 0 5.12 5.13h17.976l12.951-19.608V12.552L25.893 8.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "m24.602.012 11.94 12.54h-7.948a3.989 3.989 0 0 1-3.992-3.992V.012Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.143 26.889H8.845c-.645 0-1.174.528-1.174 1.174 0 .646.529 1.174 1.174 1.174h15.3c.645 0 1.174-.528 1.174-1.174a1.17 1.17 0 0 0-1.175-1.174ZM8.844 23.366h11.894c.646 0 1.175-.528 1.175-1.174 0-.646-.529-1.174-1.175-1.174H8.844c-.645 0-1.174.528-1.174 1.174 0 .646.529 1.174 1.174 1.174ZM20.28 32.877H8.844c-.645 0-1.174.529-1.174 1.174 0 .646.529 1.174 1.174 1.174H20.28c.646 0 1.175-.528 1.175-1.174 0-.645-.529-1.174-1.175-1.174Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#item_svg__a)",
    d: "M37.76 26.063c6.828.957 12.08 6.814 12.08 13.902C49.84 47.715 43.552 54 35.8 54c-5.33 0-9.977-2.972-12.344-7.353a14.01 14.01 0 0 1-1.696-6.693c0-7.749 6.288-14.034 14.04-14.034.66.011 1.31.055 1.96.143Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M35.5 32.4a1.5 1.5 0 0 0-1.5 1.5v3.9h-3.9a1.5 1.5 0 0 0-1.5 1.5v.6a1.5 1.5 0 0 0 1.5 1.5H34v3.9a1.5 1.5 0 0 0 1.5 1.5h.6a1.5 1.5 0 0 0 1.5-1.5v-3.9h3.9a1.5 1.5 0 0 0 1.5-1.5v-.6a1.5 1.5 0 0 0-1.5-1.5h-3.9v-3.9a1.5 1.5 0 0 0-1.5-1.5h-.6Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "item_svg__a",
    x1: 35.8,
    x2: 35.8,
    y1: 25.92,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })))));
};
export default SvgItem;